module.exports = __webpack_public_path__ + "static/media/robot-field-of-corn-2.efe22433.jpg";